const wowApp = require('angular').module('wowApp.shop');

wowApp.service('BwsNotificationService', ['$timeout', '$http', '$compile', '$templateCache', '$rootScope', '$injector', '$sce', '$q', '$window', require('./bws-notification-service')]);

wowApp.directive('bwsNotification', ['BwsNotificationService', require('./bws-notification-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/notification/index.js
 **/